import { Box } from '@mui/material';

interface AccentBarProps {
  color: string;
}

const AccentBar: React.FC<AccentBarProps> = ({ color }) => (
  <Box
    sx={{
      width: '6px',
      height: '22px',
      borderRadius: '3px',
      backgroundColor: color,
      flexShrink: 0,
    }}
  />
);

export default AccentBar;
